var _g, _g2, _path, _path2, _g3, _path3, _path4, _g4, _path5, _path6, _g5, _rect, _rect2, _path7, _path8, _path9, _path10, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot181(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 78C35.046 89.6966 18.0959 84.6663 14.6313 96.009C11.1668 107.352 22.6565 116 32.1552 116",
    stroke: "#2A3544",
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 121C158.394 124.486 170.102 113.406 166 104.5C161.898 95.5937 150 97.8056 150 85.1951",
    stroke: "#2A3544",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 72C136.895 72 136 72.8954 136 74V88C136 89.1046 136.895 90 138 90H157C158.105 90 159 89.1046 159 88V74C159 72.8954 158.105 72 157 72H138ZM21 103C21 101.895 21.8954 101 23 101H35C36.1046 101 37 101.895 37 103V121C37 122.105 36.1046 123 35 123H23C21.8954 123 21 122.105 21 121V103ZM136 110C136 108.895 136.895 108 138 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H138C136.895 130 136 129.105 136 128V110Z",
    fill: "#273951"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 72,
    width: 138,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 72C136.895 72 136 72.8954 136 74V88C136 89.1046 136.895 90 138 90H157C158.105 90 159 89.1046 159 88V74C159 72.8954 158.105 72 157 72H138ZM21 103C21 101.895 21.8954 101 23 101H35C36.1046 101 37 101.895 37 103V121C37 122.105 36.1046 123 35 123H23C21.8954 123 21 122.105 21 121V103ZM136 110C136 108.895 136.895 108 138 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H138C136.895 130 136 129.105 136 128V110Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#43A047"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.799 28.397C76.9885 20.5865 76.9885 7.92319 84.799 0.112701L98.234 13.5477L104.687 7.09466C103.781 5.56075 103.987 3.55195 105.305 2.23402C106.867 0.671925 109.4 0.671925 110.962 2.23402C112.524 3.79612 112.524 6.32878 110.962 7.89088C109.644 9.20881 107.635 9.41481 106.101 8.50887L99.6482 14.9619L113.083 28.397C107.633 33.8473 99.8196 35.4943 92.9411 33.3379V52.1127H88.9411V31.5811C87.4603 30.7252 86.0658 29.6638 84.799 28.397Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 0,
    width: 36,
    height: 53
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.799 28.397C76.9885 20.5865 76.9885 7.92319 84.799 0.112701L98.234 13.5477L104.687 7.09466C103.781 5.56075 103.987 3.55195 105.305 2.23402C106.867 0.671925 109.4 0.671925 110.962 2.23402C112.524 3.79612 112.524 6.32878 110.962 7.89088C109.644 9.20881 107.635 9.41481 106.101 8.50887L99.6482 14.9619L113.083 28.397C107.633 33.8473 99.8196 35.4943 92.9411 33.3379V52.1127H88.9411V31.5811C87.4603 30.7252 86.0658 29.6638 84.799 28.397Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.799 0.112701C76.9885 7.92319 76.9885 20.5865 84.799 28.397C92.6095 36.2075 105.273 36.2075 113.083 28.397",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.134,
    cy: 7.40558,
    r: 5.65685,
    transform: "rotate(45 108.134 7.40558)",
    fill: "white",
    fillOpacity: 0.8
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 138,
    height: 124,
    fill: "#66BB6A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 129,
    width: 68,
    height: 22,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 133,
    width: 60,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 141L78 133H66L72 141Z",
    fill: "#E1E6E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 141L90 133H78L84 141Z",
    fill: "#E1E6E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 141L102 133H90L96 141Z",
    fill: "#E1E6E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108 141L114 133H102L108 141Z",
    fill: "#E1E6E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 88,
    width: 104,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 98,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 98,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot181);
export default __webpack_public_path__ + "static/media/bot-18-1.ff7698040b139886c1049f8363691608.svg";
export { ForwardRef as ReactComponent };